module.exports = __webpack_public_path__ + "img/icon.ed428d55.svg";